import React from "react";
import { Grid } from "@material-ui/core";
import { BoxLogos } from "../BoxLogos/BoxLogos";
import { makeStyles } from "@material-ui/core/styles";
var useStyles = makeStyles(function (theme) { return ({
    logos: {
        marginBottom: theme.spacing(1),
    },
}); });
export var HeaderPayment = function (props) {
    var classes = useStyles();
    return (React.createElement(Grid, { container: true, spacing: 2 },
        React.createElement(Grid, { className: classes.logos, item: true, container: true, direction: "row", justify: "center", alignItems: "center", xs: 12 },
            React.createElement(BoxLogos, { logos: props.logos }))));
};
